import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import EmailOptInForm from '@business/contact/EmailOptInForm';


export class EmailOptInFormEntryGeneratedEntityManager<B extends EmailOptInFormEntryGenerated> extends EntityManager<B>
{

    constructor(parameters: EntityManagerParameters<B>)
    {
        super({
            name: parameters.name ?? 'EmailOptInFormEntry',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'emailOptInForm', type: BusinessEntityFieldType.ForeignKey, isRequiredInput: true, inputName: 'emailOptInFormId', inputProperty: 'emailOptInForm.id', relatedManager: EmailOptInForm.manager },
				{ name: 'dateCreated', type: BusinessEntityFieldType.DateTime, isInput: false },
				{ name: 'language', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'email', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'name', type: BusinessEntityFieldType.VarChar },
				{ name: 'phone', type: BusinessEntityFieldType.VarChar },
				{ name: 'isConfirmed', type: BusinessEntityFieldType.Boolean, isInput: false },
				{ name: 'confirmationToken', type: BusinessEntityFieldType.VarChar, isInput: false },
				{ name: 'dateConfirmed', type: BusinessEntityFieldType.DateTime, isInput: false },
				{ name: 'ipAddress', type: BusinessEntityFieldType.VarChar, isInput: false },
				{ name: 'userAgent', type: BusinessEntityFieldType.Text, isInput: false },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'emailOptInFormEntries',
        });
    }

}
/**
 * Represents a submission/entry to an email opt-in form with optional double opt-in confirmation.
 */
export class EmailOptInFormEntryGenerated extends BusinessEntity
{
	/** Reference to the email opt-in form */
	emailOptInForm!: EmailOptInForm;
	/** When the entry was created */
	dateCreated!: string;
	/** Language code used when submitting the form (ro, hu, en, de) */
	language!: string;
	/** Email address submitted */
	email!: string;
	/** Name if collected by the form */
	name: string = '';
	/** Phone number if collected by the form */
	phone: string = '';
	/** Whether the email has been confirmed (for double opt-in forms) */
	isConfirmed: boolean = false;
	/** Unique token used for email confirmation */
	confirmationToken: string = '';
	/** When the email was confirmed */
	dateConfirmed: string | null = null;
	/** IP address of the submitter */
	ipAddress: string = '';
	/** User agent string of the submitter's browser */
	userAgent: string = '';

}

export default EmailOptInFormEntryGenerated;